//eslint:disable max-func-body-length
import * as React from 'react';
import { OptionsProps } from 'app/components/options-handler';
import { Translations } from 'app/area/codetable/item/translation/translations';
import { Visibility } from 'app/area/codetable/item/visibility/visibility';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { Component } from 'react';
import { CodeEditSectionType, CodeActionType, Slot, ReadOnlyType } from 'app/area/codetable/item/types';
import styles from '../../screen-template.scss';
import { withMetroLine } from 'app/components/metro-line/with-metro-line';
import { WithMetroLineProps, WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { CodeCodetableTypes } from 'app/area/codetable/item/code-pickers/code-type';
import { shouldRenderTypes } from 'app/area/codetable/item/codetable-item-form-render-helpers';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { actionCreators } from 'app/area/codetable/item/actions';
import { CodeScreenTemplateExternalProps } from 'app/area/codetable/item/screen-renderer/screen-template';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { ReferenceDetails } from 'app/area/codetable/item/screen-renderer/screen-sections/reference/reference-details';

interface ReferenceScreenProps extends CodeScreenTemplateExternalProps {
  fetchingParentCategory?: boolean;
  codeCategoryLabel?: (translation: CodetableTranslation) => string;
}

type CodeScreenTemplateProps = ReferenceScreenProps & OptionsProps
  & Partial<typeof actionCreators> & WithMetroLineProps<CodeEditSectionType> & WithMetroLineWrappedComponentProps<CodeEditSectionType>;

class ScreenTemplatePure extends Component<CodeScreenTemplateProps> {

  private getSectionSlot = (section: CodeEditSectionType): Slot =>
    this.props.screenPayload ? this.props.screenPayload[section] : undefined;

  public render() {
    const {
      metadata, language, switchTranslationsToggle, getRef, hasBigStickyHeader, codetableOptions, readOnlyConfig,
      copyDescriptionToAllTranslations, copyLongDescriptionToAllTranslations, loadOptions, translation, actionType,
      updateDescription, updateLongDescription, codeItem, breadcrumbs, loadCodetableOptions, updateCodetableTypes,
      validation, locale
    } = this.props;

    const renderTranslationsOnTop = actionType === CodeActionType.Duplicate || shouldRenderTranslationsOnTop(codeItem);
    const shouldRenderTypesSection = shouldRenderTypes(metadata);

    return <div className={styles.screenTemplate}>
      <div>
        {renderTranslationsOnTop && <MetroLineSection<CodeEditSectionType>
          {...this.props}
          sectionType={CodeEditSectionType.Translations}
          hasBigStickyHeader={hasBigStickyHeader}
        >
          <Translations
            sectionRef={getRef(CodeEditSectionType.Translations)}
            sectionSlots={this.getSectionSlot(CodeEditSectionType.Translations)}
            {...this.props}
            metadata={metadata}
            mainLanguage={language}
            copyDescriptionToAllTranslations={copyDescriptionToAllTranslations}
            copyLongDescriptionToAllTranslations={copyLongDescriptionToAllTranslations}
            switchTranslationsToggle={switchTranslationsToggle}
            onDescriptionChange={updateDescription}
            onLongDescriptionChange={updateLongDescription}
          />
        </MetroLineSection>
        }
        <MetroLineSection<CodeEditSectionType>
          {...this.props}
          sectionType={CodeEditSectionType.Details}
          hasBigStickyHeader={hasBigStickyHeader}
        >
          <ReferenceDetails
            sectionRef={getRef(CodeEditSectionType.Details)}
            sectionSlots={this.getSectionSlot(CodeEditSectionType.Details)}
            {...this.props}
          />
        </MetroLineSection>
        <MetroLineSection<CodeEditSectionType>
          {...this.props}
          sectionType={CodeEditSectionType.Visibility}
          hasBigStickyHeader={hasBigStickyHeader}
        >
          <Visibility
            sectionRef={getRef(CodeEditSectionType.Visibility)}
            sectionSlots={this.getSectionSlot(CodeEditSectionType.Visibility)}
            {...this.props}
          />
        </MetroLineSection>
        {shouldRenderTypesSection && <MetroLineSection<CodeEditSectionType>
          {...this.props}
          sectionType={CodeEditSectionType.Types}
          hasBigStickyHeader={hasBigStickyHeader}
        >
          <CodeCodetableTypes
            sectionRef={getRef(CodeEditSectionType.Types)}
            sectionSlots={this.getSectionSlot(CodeEditSectionType.Types)}
            readOnly={readOnlyConfig && readOnlyConfig[ReadOnlyType.all]}
            metadata={metadata}
            codeItem={codeItem}
            breadcrumbs={breadcrumbs}
            options={codetableOptions}
            loadOptions={loadOptions}
            loadCodetableOptions={loadCodetableOptions}
            onChange={updateCodetableTypes}
            displaySelectAll={true}
            translation={translation}
            validation={validation}
            locale={locale} />
        </MetroLineSection>
        }
        {!renderTranslationsOnTop && <MetroLineSection<CodeEditSectionType>
          {...this.props}
          sectionType={CodeEditSectionType.Translations}
          hasBigStickyHeader={hasBigStickyHeader}
        >
          <Translations
            sectionRef={getRef(CodeEditSectionType.Translations)}
            sectionSlots={this.getSectionSlot(CodeEditSectionType.Translations)}
            {...this.props}
            metadata={metadata}
            mainLanguage={language}
            copyDescriptionToAllTranslations={copyDescriptionToAllTranslations}
            copyLongDescriptionToAllTranslations={copyLongDescriptionToAllTranslations}
            switchTranslationsToggle={switchTranslationsToggle}
            onDescriptionChange={updateDescription}
            onLongDescriptionChange={updateLongDescription}
          />
        </MetroLineSection>
        }
      </div>
    </div>;
  }
}

export const ReferenceScreen = withMetroLine<CodeScreenTemplateExternalProps, CodeEditSectionType>()(ScreenTemplatePure);

const shouldRenderTranslationsOnTop = (codeItem: CodeItem) => codeItem && !isDefinedIncludingZero(codeItem.id);
